import styled, {css} from 'styled-components';
import {Alert} from 'antd';
import {typographyStyles} from '../../utils/styles';
import {cardTypesConstants} from '../../constants';

const { DIGITAL, PHYSICAL, SUBSCRIPTION } = cardTypesConstants;

const enableLimitClassName = '.enable-limit'

const StyledCreditCard = styled.div`
  border-radius: ${props => props.error ? '16px' : '16px 16px 0 0'};
  height: ${props => props.error ? '177px' : '197px'};
  padding: ${props => props.error ? '72px 24px 28px 24px' : '32px 24px 28px 24px'};
  position: relative;
  
  ${props => props.variant === DIGITAL && css`
    background-color: ${props => props.theme.colors.additional_apple};
    color: ${props => props.theme.colors.neutral_10};
  `}
  
  ${props => props.variant === SUBSCRIPTION && css`
    background-color: #40B0D5;
    color: ${props => props.theme.colors.neutral_1};
  `}
  
  ${props => props.variant === PHYSICAL && css`
    background-color: ${props => props.theme.colors.neutral_10};
    color: ${props => props.theme.colors.neutral_1};
  `}
  
  &${enableLimitClassName} {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

const StyledCreditCardDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  padding-top: 24px;
  position: relative;
  text-transform: uppercase;
  
  .card-logo {
    position: absolute;
    top: 0;
    right: 0;
  }
`;

const StyledCreditCardOwner = styled.div`
  ${typographyStyles.body.bold};
  margin-bottom: 10px;
`;

const StyledCreditCardNumber = styled.div`
  ${typographyStyles.heading.h4};
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  margin-top: ${props => props.isPlaceholder ? 28 : 0}px;
  & > span {
    line-height: 21px;
    display: inline-block;
    
    &:not(:last-of-type) {
      margin-right: 12px;
    }
    
    &.top {
      line-height: 26px;
      height: 26px;
    }
  }
`;

const StyledCreditCardFooter = styled.footer`
  display: flex;
  justify-content: space-between;
`;

const StyledCreditCardCVVCode = styled.div`
  ${typographyStyles.body.medium};
  display: flex;
  flex-direction: column;
  
  span {
    ${typographyStyles.body.regular};
    margin-bottom: 8px;
  }
`;

const StyledCreditCardAlert = styled(Alert)`
  &.ant-alert-warning {
    background-color: ${props => props.theme.colors.functional_warning_d};
    border-color: ${props => props.theme.colors.functional_warning};
  }
`;

const StyledCreditCardTopAlert = styled(StyledCreditCardAlert)`
  ${typographyStyles.footnote.description};
  
  align-items: center !important;
  border-radius: 16px 16px 0 0;
  position: absolute;
  width: 100%;
  left: 0;
  top: -1px;
  z-index: 2;
  
  span[role="img"] {
    font-size: 15px;
  }
`;

const StyledCreditCardBottomAlert = styled(StyledCreditCardAlert)`
  align-items: start;
  border-radius: 0 0 16px 16px;
  padding: 20px 16px;
  width: 100%;
`;

const StyledCreditCardBlockedWindow = styled.div`
  background-color: rgba(217, 217, 217, 0.6);
  height: 100%;
  border-radius: ${props => props.fullBordered ? '16px' : props.isPlaceholder ? '16px 16px 0 0' : '16px'};
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  
  &${enableLimitClassName} {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

const StyledCreditCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledCreditCardLimit = styled.div`
  background-color: ${props => props.theme.colors.neutral_3};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  padding: 16px;
  width: 100%;
  
  .ant-progress-line {
    margin-bottom: 0;
  }
`;

const StyledCreditCardLimitHelper = styled.div`
  ${typographyStyles.body.regular};
  align-items: center;
  color: ${props => props.theme.colors.neutral_8};
  display: flex;
  justify-content: space-between;

  .ant-progress {
    &.ant-progress-status-success {
      background-color: ${props => props.theme.colors.primary_4};
    }
    &.ant-progress-status-exception {
      background-color: ${props => props.theme.colors.functional_danger};
    }
  }
`;

const StyledCreditCardErrorMessage = styled.div`
  font-size: 16px;
  text-align: center;
`;

const StyledCreditCardFrozenBackground = styled.div`
  backdrop-filter: blur(2px);
  border-radius: 16px 16px 0 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const StyledCreditCardFrozenMessage = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_1};
  border-radius: 2px;
  color: #4294FF;
  display: flex;
  font-size: 14px;
  left: 20px;
  line-height: 20px;
  padding: 2px 12px 2px 2px;
  position: absolute;
  top: 16px;
  
  img {
    margin-right: 5px;
  }
`;

export {
  StyledCreditCard,
  StyledCreditCardDetails,
  StyledCreditCardOwner,
  StyledCreditCardNumber,
  StyledCreditCardFooter,
  StyledCreditCardCVVCode,
  StyledCreditCardTopAlert,
  StyledCreditCardBottomAlert,
  StyledCreditCardBlockedWindow,
  StyledCreditCardContainer,
  StyledCreditCardLimit,
  StyledCreditCardLimitHelper,
  StyledCreditCardErrorMessage,
  StyledCreditCardFrozenBackground,
  StyledCreditCardFrozenMessage,
}
